<template>
  <panel :title="product.title" class="blue-panel">
    <div class="l-col-12@md">
      <panel>
        <div class="l-row">
          <div class="l-col-1@md img-product">
            <img :src="product.images[0]" class="product-img">
          </div>

          <div class="l-col-9@md">
            <div class="l-row">
              <div class="l-col-3@md">
                <span><strong>EAN:</strong> {{ product.ean }}</span>
              </div>
              <div class="l-col-3@md">
                <span><strong>Marca:</strong> {{ product.brand }}</span>
              </div>
              <div class="l-col-3@md" v-for="attribute in product.attributes" :key="attribute">
                <span><strong>{{ attribute.label }}:</strong> {{ attribute.valor }}</span>
              </div>
            </div>
          </div>

          <div class="l-col-2@md u-textRight center-vertical">
            <button class="btn btn--success" @click="showConfirmSelectMatch()" :disabled="product.selectedMatchSku || newSku">{{ newSku ? 'Selecionado' : 'Considerar como novo'  }}</button>
          </div>
        </div>
      </panel>
    </div>
    <div class="l-col-12@md u-textCenter">
      <i class="icon-arrow icon-arrow-down"></i>
    </div>

    <div class="l-col-12@md">
      <p><strong>Selecione o produto com o match adequado:</strong></p>
    </div>

    <div class="l-col-12@md" v-for="availableMatch in product.availableMatches" :key="availableMatch">
      <panel>
        <div class="l-row">
          <div class="l-col-1@md img-product">
            <div class="l-col-4@md">
              <circle-chart :percent="availableMatch.percent" :color="percentColor(availableMatch.percent)">{{ availableMatch.percent }}%</circle-chart>
            </div>
          </div>
          <div class="l-col-2@md u-textCenter">
            <img :src="availableMatch.image" class="product-availablematch-img">
          </div>
          <div class="l-col-7@md">
            <div class="l-row">
              <div class="l-col-12@md available-title">{{ availableMatch.title }}</div>
              <div class="l-col-3@md">
                <span><strong>EAN:</strong> {{ availableMatch.ean }}</span>
              </div>
              <div class="l-col-3@md">
                <span><strong>Marca:</strong> {{ availableMatch.brand }}</span>
              </div>
              <div class="l-col-3@md" v-for="attribute in availableMatch.attributes" :key="attribute">
                <span><strong>{{ attribute.label }}:</strong> {{ formatAttribute(attribute.value) }}</span>
              </div>
            </div>
          </div>
          <div class="l-col-2@md u-textRight center-vertical">
            <button class="btn btn--success" @click="showConfirmSelectMatch(availableMatch)" :disabled="product.selectedMatchSku || newSku">{{ availableMatch.sku === selectedMatch ? 'Selecionado' : 'Selecionar'  }}</button>
          </div>
        </div>

        <select-match v-model="selectMatchItemFlag" :newSku="newSku" v-on:option="selectMatch"/>
      </panel>
    </div>
  </panel>
</template>

<script>
  import api from '@/api'
  import Panel from '@/components/template/Panel'
  import SelectMatch from '@/components/ProductMatch/SelectMatch'
  import notifier from '@/notifier'

  export default {
    props: {
      product: {
        type: Object,
        required: true
      }
    },
    data: () => ({
      selectMatchItemFlag: false,
      selectedMatch: null,
      newSku: false
    }),
    methods: {
      formatAttribute (value) {
        if (value.indexOf('|') !== -1) {
          value = value.replace(/\|/g, ', ')
        }

        return value
      },
      percentColor (percent) {
        if (percent < 33) {
          return '#d62728'
        }

        if (percent >= 33 && percent < 67) {
          return '#FFA500'
        }

        return '#4f8a10'
      },
      showConfirmSelectMatch (product) {
        this.selectedMatch = null
        this.newSku = false

        if (product !== undefined) {
          this.selectedMatch = product.sku
        } else {
          this.newSku = true
        }

        this.selectMatchItemFlag = true
      },
      selectMatch (option) {
        if (!option) {
          this.selectedMatch = false
          this.newSku = false
          return false
        }

        const match = {}

        if (this.selectedMatch !== null) {
          match.selectedMatchSku = this.selectedMatch
        }

        if (this.newSku) {
          match.newSku = true
        }

        api.cnova.saveMatch(this.product.sku, match)
          .then(result => {
            this.product.status = 'confirm'
            this.product.selectedMatchSku = this.selectMatch()

            notifier.success('Match realizado com sucesso.', 'Sucesso')
          })
          .catch(() => {
            notifier.error('Erro ao realizar o match do produto.', 'Erro')
          })
      }
    },
    components: {
      Panel,
      SelectMatch
    }
  }
</script>

<style lang="sass" scoped>
  .img-product
    text-align: center

  .product-img
    max-width: 75px

  .icon-arrow
    font-size: 35px
    margin-bottom: 10px

  strong
    display: block

  .product-availablematch-img
    max-width: 75px

  .available-title
    margin-bottom: 16px

  .center-vertical
    &::before
      content: ''
      height: 100%
      display: inline-block
      vertical-align: middle
</style>



// WEBPACK FOOTER //
// Card.vue?5a12eb08